module.exports = __webpack_public_path__ + "static/spend-and-win-913cf794d441c121863c9cb6ed6e9bde.png";